import $ from 'jquery';
import prettyphoto from 'prettyphoto';
import jflickrfeed from 'jflickrfeed';

/*
============================================================================
  Template Scripts
============================================================================= */

//function Template() {
//    if (false === (this instanceof Template)) {
//        return new Template();
//    }
//}

export default (function () {
    function internalRender () {
        /* HEADER AUTO TOGGLE
        ================================================== */
        var topbarH = $("#top-bar").height();

        $(window).scroll(function () {

            //var scrollPos = $(window).scrollTop();

            //if (scrollPos > topbarH) {
            //    $("#header").addClass('fixed');
            //    $("#top-bar").hide().removeClass("open");
            //    $(".top-bar-toggle").removeClass("open");
            //} else {
            //    $("#top-bar").show().addClass("open");
            //    $(".top-bar-toggle").addClass("open");
            //    $("#header").removeClass('fixed');
            //}

        });

        /* PRETTY PHOTO
        ================================================== */
        $("a[data-gal^='prettyPhoto']").prettyPhoto({ hook: 'data-gal' });


        /* FOOTER FLICKR FEED
        ================================================== */
        $('#footer-flickr-stream').jflickrfeed({
            limit: 6,
            qstrings: {
                id: '52914122@N05'
            },
            itemTemplate: '<li><a href="{{image_b}}"><img src="{{image_s}}" alt="{{title}}" /></a></li>'
        });


        /* OTHER FLICKR FEEDS
            ================================================== */

        $('[data-feed="flickr"]').each(function () {

            $(this).jflickrfeed({
                itemTemplate: '<li style="item_style"><a href="{{image_b}}"><img src="{{image_s}}" alt="{{title}}" /></a></li>'
            });

        });



        /* FOOTER TWITTER FEED
        ================================================== */
        //$('#footer-tweets').tweetable({
        //    username: "twitter",
        //    replies: false,
        //    limit: 3,
        //    rotate: true,
        //    position: 'append',
        //    failed: "Sorry, twitter is currently unavailable for this user.",
        //    loading: "Loading tweets...",
        //    html5: true,
        //    onComplete: function ($ul) {
        //        $('time').timeago();
        //    }
        //});

        /* CUSTOM TOGGLE
        ================================================== */
        $("*[data-custom-toggle]").each(function () {
            $(this).click(function () {

                var target = $(this).attr('data-target');
                var tclass = $(this).attr('data-class');
                var tmode = $(this).attr('data-custom-toggle');

                // Toggle classes if supplied
                if (tclass) {
                    $(this).toggleClass(tclass);
                    $(target).toggleClass(tclass);
                }

                switch (tmode) {

                    case "slide":
                        $(target).slideToggle('slow');
                        break;

                    case "visibility":
                        $(target).toggle('slow');
                        break;

                        // Extend more options here...
                }

            });
        });



        /* SIDE-LINKS TOGGLE
        ================================================== */
        $(".side-links .toggle-children").click(function () {
            $(this).toggleClass('open').next().toggle("slow");

        });


        /* STYLE SWITCHER (DELETE WHEN NO LONGER NEEDED!!)
        ================================================== */

        $('#style-switcher .ctrl').click(function (e) {
            $('#style-switcher .styles').toggle('slow');
        });

        $('#style-switcher .colors li').click(function (e) {

            var sheet = $(this).attr('data-sheet');

            if ($('#demo-skin').length > 0) {

                $('#demo-skin').attr('href', sheet);

            } else {

                $('<link>').attr('rel', 'stylesheet')
              .attr('id', 'demo-skin')
              .attr('type', 'text/css')
              .attr('href', sheet)
              .appendTo('head');

            }


        });

        $('#style-switcher .input-pagebg').click(function (e) {

            var val = $(this).val();

            switch (val) {

                case "solid":
                    $("body").removeClass('overlay');
                    break;

                case "picture":
                    $("body").addClass("overlay");
                    break;

            }
        });

        $('#style-switcher .input-contbg').click(function (e) {

            var val = $(this).val();

            switch (val) {

                case "solid":
                    $(".content-block .overlay, .intro-block .overlay, .page-title .overlay").removeClass("default").addClass("color-2-bg");
                    break;

                case "picture":
                    $(".content-block .overlay, .intro-block .overlay, .page-title .overlay").removeClass("color-2-bg").addClass("default");
                    break;
            }
        });

        $('#style-switcher .input-layout').click(function (e) {

            var val = $(this).val();
            $('#page-wrapper').removeClass('wide boxed').addClass(val);
            adaptHeader();
        });

        $("*[data-remove-class]").each(function () {
            var str = $(this).attr("data-remove-class");
            $(this).removeClass(str);
        });

        //bxslider-4
        $('[data-call="bxslider"]').each(function () {
            $(this).bxSlider();
        });
    };
    function test(){alert("RENDER")};
    var API = {
        render : function(){
            //test();
            internalRender();
        }
    };

    return API;
})();



